import { ApiKeyOrGetter } from "./GeneralService";
import GeneralService from "./GeneralService";

export class TestSetService {
  public static addRequestToTestSet(
    payload: any,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter,
  ) {
    return GeneralService.put(
      "/test_sets/request/add",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static removeRequestFromTestSet(
    payload: any,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter,
  ) {
    return GeneralService.delete(
      "/test_sets/request/remove",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static getTestSets(loadingHandler: any, apiKey: ApiKeyOrGetter) {
    return GeneralService.get(
      "/test_sets/",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static getTestSetsUnified(
    offset: number,
    limit: number,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.get(
      `/test_sets/unified/${offset}/${limit}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static getTestSet(
    testSetId: string,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter,
  ) {
    return GeneralService.get(
      `/test_sets/${testSetId}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static getTestSetsByIntentGroup(
    intentGroupId: string,
    offset: number,
    limit: number,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter,
  ) {
    return GeneralService.get(
      `/test_sets/intent-group/id/${intentGroupId}/${offset}/${limit}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static getTestSetsByApplicationIntent(
    applicationId: number,
    intentId: number,
    offset: number,
    limit: number,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter,
  ) {
    return GeneralService.get(
      `/test_sets/application/${applicationId}/intent/${intentId}/${offset}/${limit}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static getTestSetsByDatasetId(
    datasetId: number,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter,
  ) {
    return GeneralService.get(`/test_sets/dataset/${datasetId}`, loadingHandler, JSON, GeneralService.PROD_ENDPOINT, apiKey);
  }

  public static getTestSetsCreatedFromDataset(
    datasetId: number,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter,
  ) {
    return GeneralService.get(
      `/test_sets/dataset/${datasetId}/source`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static getTestSetRequests(
    testSetId: string,
    startDate: number,
    endDate: number,
    offset: number,
    limit: number,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter,
  ) {
    return GeneralService.get(
      `/test_sets/${testSetId}/requests/${startDate}/${endDate}/${offset}/${limit}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static getEligibleTestSetRequests(
    intentGroupId: number,
    testSetId: number,
    beforeDate: number,
    offset: number,
    limit: number,
    sessionId: string | null,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter,
  ) {
    const sessionParam = sessionId
      ? `?session_id=${encodeURIComponent(sessionId)}`
      : "";
    return GeneralService.get(
      `/test_sets/requests/eligible/${intentGroupId}/${testSetId}/${beforeDate}/${offset}/${limit}${sessionParam}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static searchEligibleTestSetRequests(
    intentGroupId: number,
    testSetId: number,
    query: string,
    keywords: string[],
    loadingHandler: any,
    apiKey: ApiKeyOrGetter,
  ) {
    return GeneralService.post(
      `/test_sets/requests/eligible/${intentGroupId}/${testSetId}/search`,
      JSON.stringify({ query, keywords }),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static createTestSet(
    payload: any,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter,
  ) {
    return GeneralService.post(
      "/test_sets/",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static updateTestSet(
    payload: any,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter,
  ) {
    return GeneralService.put(
      "/test_sets/edit",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static deleteTestSet(
    testSetId: string,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter,
  ) {
    return GeneralService.delete(
      `/test_sets/${testSetId}`,
      JSON.stringify({}),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static addTestSetRequests(
    payload: any,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter,
  ) {
    return GeneralService.put(
      "/test_sets/requests/add",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static removeTestSetRequests(
    payload: any,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter,
  ) {
    return GeneralService.put(
      "/test_sets/requests/remove",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static updateTestSetRequestTags(
    testSetId: string,
    requestId: string,
    tags: string[],
    loadingHandler: any,
    apiKey: ApiKeyOrGetter,
  ) {
    return GeneralService.put(
      `/test_sets/${testSetId}/requests/${requestId}/tags`,
      JSON.stringify({ tags: tags }),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static updateTestSetRequestResponse(
    testSetId: string,
    requestId: string,
    payload: any,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter,
  ) {
    return GeneralService.put(
      `/test_sets/${testSetId}/requests/${requestId}/response`,
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static getTestSetRequestDistribution(
    testSetId: string,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter,
  ) {
    return GeneralService.get(
      `/test_sets/${testSetId}/request_distribution`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }
}
